module.exports = __webpack_public_path__ + "static/media/TimesChange-tile.eac6e657.jpg";